import ApiCalls from "../util/ApiCalls";

class ChatService {
    async sendRequest(chatRequest) {
        return ApiCalls.defaultPost("/chat", {}, chatRequest);
    }
}

export default new ChatService();